import React from 'react';
import './Footer.css';

const Footer = () => {
        return (
                <div className="brand-bg">
                        <div className="footer container d-flex justify-content-center align-items-center">
                                <div className="text-center">
                                        <p className="text-white m-0 p-0">Copyright © 2022 || <span className="brand-color">macbook-analysis.netlify.app</span></p>
                                        <p className="text-white m-0 p-0 mt-2"><small>Mymensingh, Bangladesh</small></p>
                                        <p className="text-white m-0 p-0 mt-2"><small>All Rights Reserved.</small></p>
                                </div>
                        </div>
                </div>
        );
};

export default Footer;